
import React, { useMemo } from 'react';

// Memoize the static cells array outside the component
const digitCells = [
  { digit: 0, cells: [0,0,0,0,0,0,0,0,0] },
  { digit: 1, cells: [1,0,0,0,0,0,0,0,0] },
  { digit: 2, cells: [1,1,0,0,0,0,0,0,0] },
  { digit: 3, cells: [1,1,1,0,0,0,0,0,0] },
  { digit: 4, cells: [1,1,1,0,0,1,0,0,0] },
  { digit: 5, cells: [1,1,1,0,0,1,0,0,1] },
  { digit: 6, cells: [1,1,1,0,0,1,0,1,1] },
  { digit: 7, cells: [1,1,1,0,0,1,1,1,1] },
  { digit: 8, cells: [1,1,1,1,0,1,1,1,1] },
  { digit: 9, cells: [1,1,1,1,1,1,1,1,1] }
];

const DigitGrid = ({ value }) => {
  // Memoize the lookup for the current digit
  const thisCell = useMemo(() => {
    return digitCells.find(cell => cell.digit === parseInt(value));
  }, [value]);

  return (
    <div className="digit-grid">
      {[...Array(9)].map((_, i) => (
        <div key={i} className={`digit-cell${thisCell && thisCell.cells[i] === 1 ? ' active' : ''}`}></div>
      ))}
    </div>
  );
};

export default DigitGrid;